import { OfferingTransaction, TransactionStatus } from '@arrived/models';

import { COMPLETE_TRANSACTION_STATUSES } from '../constants';

export function isTransactionIncludedInAccountBalance(transaction: OfferingTransaction) {
  return (
    COMPLETE_TRANSACTION_STATUSES.includes(transaction.status) ||
    transaction.status === TransactionStatus.CREATED_PENDING
  );
}
